import { composeIO } from 'react-compose-io'
import { parametroContabilDetalhesIO } from './ParametroContabilDetalhes.IO'
import { ParametroContabilDetalhesView } from './ParametroContabilDetalhes.View'

export const ParametroContabilDetalhes = composeIO(ParametroContabilDetalhesView, parametroContabilDetalhesIO)
